export const ROLES = {
  ADMIN: 'admin',
  GESTOR: 'manager',
  USER: 'employee',
  CUSTOMER: 'customer',
} as const;

export type Role = typeof ROLES[keyof typeof ROLES];

export const ROLE_LABELS: Record<Role, string> = {
  [ROLES.ADMIN]: 'Administrador',
  [ROLES.GESTOR]: 'Gestor',
  [ROLES.USER]: 'Usuário',
  [ROLES.CUSTOMER]: 'Customer',
}; 


export enum UserRole {
  admin = 'admin',
  manager = 'manager',
  employee = 'employee',
  outsourced = 'outsourced',
  customer = 'customer',
  guest = 'guest',
}
